import gems from 'assets/gems.png';

type Props = { width?: number; height?: number };
export const GemsIcon = ({ width, height }: Props) => (
  <img width={width} height={height} src={gems} alt="Gems" />
);
